import { createSlice } from "@reduxjs/toolkit";

const defaultCollectionState = {
  loading: true,
  error: "",
  data: [],
};

const initialState = {};

const buildIdMap = (data) => {
  if(!data) return {};
  const idMap = {};
  for(let i = 0; i < data.length; i++) {
    idMap[data[i].id] = data[i];
  }
  return idMap;
}

const collections = createSlice({
  name: "collections",
  initialState: initialState,
  reducers: {
    reset() {
      return initialState;
    },
    setCollectionState(state, action) {
      const { collectionName, ...collectionState } = action.payload;
      if(!state[collectionName]) {
        state[collectionName] = {...defaultCollectionState};
      }
      const documents = collectionState.documents;
      state[collectionName] = {
        ...state[collectionName], 
        ...collectionState,
        idMap: buildIdMap(documents),
      };
    },
  }
});

export const collectionsActions = collections.actions;

export default collections.reducer;